import getOptions from '../selectors/getOptions';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default function () {
    var savedOptions = getOptionsForFeature(OwsOptionsFeatureType.GdprAdsPrefs);
    var options = getOptions();
    return (options.allowAccess !== savedOptions.allowStorageAndAccess ||
        options.allowAdSelection !== savedOptions.allowAdSelectionDeliveryReporting ||
        options.allowContentSelection !== savedOptions.allowContentSelectionDeliveryReporting ||
        options.allowPersonalization !== savedOptions.allowPersonalization ||
        options.allowMeasurement !== savedOptions.allowMeasurement);
}
//# sourceMappingURL=isDirty.js.map